<!--
================================================
Vue gérant le logout de l'utilisateur
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <outdoor-layout-comp>
        <div slot="AppContent">
            Logout !
            <!--<component></component>-->
            <a href="/login">Login</a>
        </div>
    </outdoor-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import OutdoorLayoutComp from '@/components/OutdoorLayoutComp.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'LogoutView',
        components: {
            OutdoorLayoutComp,
            // Component,
        },
        mixins: [VueMetaMixin, TrackingMixin],
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleDefault"),this.$t("metaDescDefault"))
        },
        //==========================================================
        methods: {
            /*
                Déconnecte l'user actuel
             */
            logoutUser(){
                this.$auth.removeCookie()
            },

            /**
             * Réinitialise les éléments du store liés à l'utilisateur.
             * Permet d'éviter d'afficher des informations d'un ancien utilisateur
             */
            userReset(){
                // on vide tout ce qui concerne l'utilisateur
                this.$store.commit('UpdateOrganization', null);
                this.$store.commit('UpdateUserSlug', null);
                this.$store.commit('UpdateUserGender', null);
                this.$store.commit('UpdateUserFirstname', null);
                this.$store.commit('UpdateUserEmail', null);
                this.$store.commit('UpdateUserCurrentAccountEmail', null);
                this.$store.commit('UpdateUserCurrentTimeRecord', null);

                this.$store.commit('UpdateAppStoreInitToken', null); // forcera l'appli à recharger le nouvel utilisateur...
                this.$store.commit('UpdateMyRecentActivityComp', {timerecords: []});  // vidage des timerecords
                this.$store.commit('UpdateTaskTimerecordListComp', {timerecords: []});  // vidage des timerecords

                this.$store.commit('UpdateTimeTrackingViewCurrentTask', null);
                this.$store.commit('UpdateTimeTrackingViewProjectsGroupedByClient',null)

                this.$store.commit('UpdateTimeTrackingViewProjectsGroupedByClient',null)

                this.$store.commit('UpdateProjectsViewProjects',null)
                this.$store.commit('UpdateClientsViewClients',null)
                this.$store.commit('UpdateTimeTrackingSuggestedTrTimerecords',[])
                this.$store.commit('UpdateTimeTrackingSuggestedTrIndexCurrentActive',null)
                this.$store.commit('UpdateThemeToDisplay', null)
                this.$store.commit('UpdateUserPreferedTheme', null)
                this.$store.commit('UpdateSubscriptionViewWorkspaceTrialStarted', null)
                this.$store.commit('UpdateSubscriptionViewWorkspaceTrialEnd', null)
                this.$store.commit('UpdateTagsViewTags', null)

              // this.$store.commit('UpdateUserActiveWorkspace',null);

            }
        },
        created: function () {
            this.userReset();
            this.logoutUser()

            this.ga4GlobalEventTrack('Logout', {})

            this.$mixpanel.track('logout')
            this.$mixpanel.reset() // https://help.mixpanel.com/hc/en-us/articles/115004497803-Identity-Management-Best-Practices

            this.$router.replace('login')

        },
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">


</style>
